<template>
  <div class="layout">
    <h2 class="title blind">기타자료실</h2>
    <div class="search-wrap align-between">
      <span class="total">전체 : <span>{{ total }}</span>건</span>
      <div class="search-box">
        <div class="bundle list-btn-wrap">
          <button type="button" @click="toggleClass($event, 'col1')" class="list-option-btn list-type">col*1</button>
          <button type="button" @click="toggleClass($event, 'col2')"
            class="list-option-btn thumbnail-type on">col*2</button>
        </div>
        <label for="codeId" class="ir">검색카테고리</label>
        <select v-model="codeId" id="codeId" @change="searchCombo($event)">
          <option value="">전체</option>
          <option v-for="(data, idx) in selectCodeListEtc" v-bind:key="idx" :value="data.codeId">{{ data.codeKorNm }}
          </option>
        </select>
        <label for="txtName" class="ir">제목/내용순서</label>
        <select name="" id="txtName">
          <option value="">제목 / 내용</option>
        </select>
        <label for="searchText2" class="ir">검색창</label>
        <input type="search" v-model="searchText" id="searchText2" v-on:keyup.enter="searchBoardTotalList(1, 10, 1)" />
        <button type="submit" @click="searchBoardTotalList(1, 10, 1)">검색</button>
      </div>
    </div>
    <!-- <div class="category-btn-list">
      <button type="button" @click="clickTab($event)" class="on">전체</button>
      <button type="button" v-for="(data, idx) in selectCodeListEtc" v-bind:key="idx" :value="data.codeId"
        @click="clickTab($event)">{{ data.codeKorNm }}</button>
    </div> -->
    <IndexReportListItem :board-list-data="listData" :searchText="this.searchText" :boardName="this.boardName"
      @showDetailView="showDetailView" />
    <BoardPagination :pageSetting="pageDataSetting(this.page)" @paging="pagingMethod" />
  </div>
</template>

<script>
import * as api from '@/api/Notice.js'
import IndexReportListItem from '@/components/IndexReportListItem'
import BoardPagination from '@/components/BoardPagination'

export default {
	name: 'EtcData',

	components: {
		IndexReportListItem,
		BoardPagination
	},

	props: {
		paramCodeId: {
			type: String,
			default: ''
		}
	},

	data () {
		return {
			boardType: '000035,000311',
			boardName: '기타자료실',
			searchText: '',
			codeId: this.paramCodeId,
			listData: [],
			selectCodeListEtc: [],
			total: 0,
			page: 1,
			limit: 10,
			block: 10,
			startIdx: 1,
			endIdx: 10
		}
	},

	created () {
		this.initBoard()
	},

	mounted () {
		if (window.innerWidth <= 768) {
			this.block = 5
		}
	},

	methods: {
		initBoard () {
			if (this.$route.query.page) {
				this.page = this.$route.query.page
			}

			if (this.$route.query.searchText) {
				this.searchText = this.$route.query.searchText
			}

			if (this.$route.query.codeId) {
				this.codeId = this.$route.query.codeId
			}

			this.searchBoardTotalList(this.page)
		},

		toggleClass (event, colType) {
			const ebookList = document.querySelector('.ebook-list')
			const listBtnWrap = document.querySelectorAll('.list-btn-wrap button')
			if (colType === 'col1') {
				ebookList.classList.add('on')
			} else if (colType === 'col2') {
				ebookList.classList.remove('on')
			}
			listBtnWrap.forEach(elm => elm.classList.remove('on'))
			event.target.classList.add('on')
		},
		clickTab (event) {
			const categoryWrap = document.querySelectorAll('.category-btn-list button')
			categoryWrap.forEach(obj => obj.classList.remove('on'))
			event.target.classList.add('on')

			this.codeId = event.target.value
			this.page = 1
			this.searchBoardTotalList(this.page)
		},

		// 게시판 상세보기 화면 이동
		showDetailView (boardId, boardType, orderRowNum) {
			const paramData = {
				boardId: boardId,
				boardType: boardType,
				target: '기타 자료실',
				page: this.page + '',
				searchText: this.searchText,
				codeId: this.codeId,
				orderRowNum: orderRowNum
			}

			this.$router.push({ name: '기타자료실 상세', query: paramData })
		},

		// 게시판 전체 목록
		async searchBoardTotalList (currentPage) {
			this.startIdx = ((currentPage - 1) * this.limit) + 1
			this.endIdx = currentPage * this.limit
			this.page = currentPage

			const codeData = await api.selectCodeListEtc()
			if (!codeData.data.length == this.selectCodeListEtc.length) {
				codeData.data.forEach(data => this.selectCodeListEtc.push(data))
			}

			const paramData = {
				boardType: this.boardType,
				stblType: this.codeId,
				searchText: this.searchText,
				startPage: this.startIdx,
				endPage: this.endIdx
			}

			const boardData = await api.searchBoardList(paramData)
			this.listData = boardData.data

			const totalCnt = await api.boardCnt(paramData)
			this.total = totalCnt.cnt

			const totalPages = Math.ceil(this.total / this.limit)

			if (this.page > totalPages) {
				this.page = totalPages > 0 ? totalPages : 1
				if (this.page > 1) {
					this.searchBoardTotalList(this.page)
				}
				return
			}

			this.pageDataSetting(currentPage)
		},

		pagingMethod (page) {
			this.$router.replace({
				name: '기타 자료실',
				query: {
					page: page,
					searchText: this.searchText,
					codeId: this.codeId
				}
			}).catch(() => { })
		},

		pageDataSetting (currentPage) {
			const totalPage = Math.ceil(this.total / this.limit)
			const first = currentPage > 1 ? parseInt(currentPage, 10) - parseInt(1, 10) : null
			const end = totalPage !== currentPage ? parseInt(currentPage, 10) + parseInt(1, 10) : null

			const startIndex = (Math.ceil(currentPage / this.block) - 1) * this.block + 1
			const endIndex = startIndex + this.block > totalPage ? totalPage : startIndex + this.block - 1
			const list = []
			for (let index = startIndex; index <= endIndex; index++) {
				list.push(index)
			}
			return { first, end, list, currentPage, totalPage }
		}
	},

	watch: {
		$route (to, from) {
			if (to.path === from.path) {
				this.initBoard()
			}
		},
		paramCodeId: function () {
			this.codeId = this.paramCodeId
			this.searchBoardTotalList(this.startIdx, this.endIdx, this.page)
		}
	}
}
</script>

<style scoped></style>
